var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClose2 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59375 5.5L8.9375 7.84375C9.07812 7.98438 9.14844 8.15625 9.14844 8.35938C9.14844 8.5625 9.07812 8.74219 8.9375 8.89844L8.42188 9.41406C8.26562 9.55469 8.08594 9.625 7.88281 9.625C7.67969 9.625 7.50781 9.55469 7.36719 9.41406L5.02344 7.07031L2.67969 9.41406C2.53906 9.55469 2.36719 9.625 2.16406 9.625C1.96094 9.625 1.78125 9.55469 1.625 9.41406L1.10938 8.89844C0.96875 8.74219 0.898438 8.5625 0.898438 8.35938C0.898438 8.15625 0.96875 7.98438 1.10938 7.84375L3.45312 5.5L1.10938 3.15625C0.96875 3.01562 0.898438 2.84375 0.898438 2.64062C0.898438 2.4375 0.96875 2.25781 1.10938 2.10156L1.625 1.58594C1.78125 1.44531 1.96094 1.375 2.16406 1.375C2.36719 1.375 2.53906 1.44531 2.67969 1.58594L5.02344 3.92969L7.36719 1.58594C7.50781 1.44531 7.67969 1.375 7.88281 1.375C8.08594 1.375 8.26562 1.44531 8.42188 1.58594L8.9375 2.10156C9.07812 2.25781 9.14844 2.4375 9.14844 2.64062C9.14844 2.84375 9.07812 3.01562 8.9375 3.15625L6.59375 5.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.898438,
    y: 0.375,
    width: 8.25,
    height: 9.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/close2.b8a6ca13.svg";
export { ForwardRef as ReactComponent };